"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicesPageWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var HeaderCell_1 = __importDefault(require("atomicComponents/molecules/Table/HeaderCell"));
var StickyRow_1 = require("atomicComponents/molecules/Table/TableRows/StickyRow");
var TabbedStackLayout_1 = __importDefault(require("atomicComponents/organisms/Layout/TabbedStackLayout"));
var SortableHeader_1 = __importDefault(require("atomicComponents/organisms/SortableHeader"));
var context_1 = __importDefault(require("components/Money/context"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var backend_1 = require("utils/backend");
var HoCs_1 = require("utils/HoCs");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var populated_1 = require("utils/selectors/populated");
var single_1 = require("utils/selectors/single");
var constants_1 = require("./constants");
var context_2 = require("./context");
var InvoiceElement_1 = __importDefault(require("./InvoiceElement"));
var InvoiceSearchAndFilter_1 = __importDefault(require("./InvoiceSearchAndFilter"));
var tableConf_1 = require("./tableConf");
var utils_1 = require("./utils");
var MONEY_CONTEXT_VAL = { fixedDecimals: true, currency: '' };
var RECHARGE_INVOICES_TABS = __spreadArray([
    { label: 'All invoices', href: '/recharges/invoices/all' }
], __read(constants_1.STATUS_SLUGS.map(function (slug) { return (__assign({ href: "/recharges/invoices/".concat(slug), label: (0, end2end_1.kebabToProper)(slug) }, (0, pick_1.default)(constants_1.INVOICE_STATUS_MAPPER[constants_1.FILTER_KEY_TO_STATUS[slug]], ['icon', 'iconColor']))); })), false);
var InvoicesPage = function (_a) {
    var filterKey = _a.filterKey, isMakingInvoices = _a.isMakingInvoices;
    var _b = __read((0, react_1.useState)(null), 2), openModal = _b[0], setOpenModal = _b[1];
    var allRechargeInvoices = (0, react_redux_1.useSelector)(populated_1.selectPopRechargeInvoices);
    var rechargeInvoices = (0, react_1.useMemo)(function () {
        var sortedInvoices = filterKey === 'all'
            ? allRechargeInvoices
            : allRechargeInvoices && allRechargeInvoices.filter(function (inv) {
                var fullStatus = (0, end2end_1.getFullStatus)(inv);
                if (filterKey === 'refunded') {
                    return ['refunded', 'refunding'].includes(fullStatus);
                }
                if (filterKey === 'paid') {
                    return ['paid', 'paidOutOfBand'].includes(fullStatus);
                }
                return fullStatus === constants_1.FILTER_KEY_TO_STATUS[filterKey];
            });
        sortedInvoices === null || sortedInvoices === void 0 ? void 0 : sortedInvoices.sort(function (inv1, inv2) { var _a, _b, _c, _d; return (((_b = (_a = inv2.date) === null || _a === void 0 ? void 0 : _a.toMillis()) !== null && _b !== void 0 ? _b : 0) + inv2.subTotal) - (((_d = (_c = inv1.date) === null || _c === void 0 ? void 0 : _c.toMillis()) !== null && _d !== void 0 ? _d : 0) + inv1.subTotal); });
        return sortedInvoices;
    }, [filterKey, allRechargeInvoices]);
    var _c = __read((0, utils_1.useFilterMapping)(rechargeInvoices !== null && rechargeInvoices !== void 0 ? rechargeInvoices : []), 3), filteredInvoices = _c[0], searchProps = _c[1], filterProps = _c[2];
    var _d = __read((0, useInfiniteScroll_1.default)(filteredInvoices || [], 30), 2), pagedInvoices = _d[0], loaderRef = _d[1];
    if (!(0, react_redux_firebase_1.isLoaded)(pagedInvoices)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var OpenModal = openModal && utils_1.MODALS_CONF[openModal.modalKey];
    var openModalItem = ((openModal === null || openModal === void 0 ? void 0 : openModal.itemId) && (allRechargeInvoices === null || allRechargeInvoices === void 0 ? void 0 : allRechargeInvoices.find(function (item) { return item.id === (openModal === null || openModal === void 0 ? void 0 : openModal.itemId); })))
        || (openModal === null || openModal === void 0 ? void 0 : openModal.item) || undefined;
    var hasMore = pagedInvoices.length < ((filteredInvoices === null || filteredInvoices === void 0 ? void 0 : filteredInvoices.length) || 0);
    return ((0, jsx_runtime_1.jsxs)(context_1.default.Provider, __assign({ value: MONEY_CONTEXT_VAL }, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Invoices", description: "Recharges - Invoices" }), OpenModal && openModalItem && (0, jsx_runtime_1.jsx)(OpenModal, { item: openModalItem, onClose: function () { return setOpenModal(null); } }), (0, jsx_runtime_1.jsxs)(TabbedStackLayout_1.default, __assign({ tabs: RECHARGE_INVOICES_TABS }, { children: [(0, jsx_runtime_1.jsx)(InvoiceSearchAndFilter_1.default, __assign({ invoices: allRechargeInvoices !== null && allRechargeInvoices !== void 0 ? allRechargeInvoices : [] }, searchProps, filterProps)), (0, jsx_runtime_1.jsx)(context_2.InvoiceModalContext.Provider, __assign({ value: setOpenModal }, { children: (0, jsx_runtime_1.jsx)(Table_1.default, __assign({ width: 845 }, { children: !pagedInvoices.length
                                ? (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: isMakingInvoices ? 'Generating invoices...' : 'No invoices to show' }))
                                : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StickyRow_1.StickyTopRow, __assign({ top: 0 }, { children: (0, jsx_runtime_1.jsxs)(HeaderCell_1.default, __assign({ hasGutter: true, width: 844 }, { children: [(0, jsx_runtime_1.jsx)(SortableHeader_1.default, { text: "Invoices (".concat((filteredInvoices === null || filteredInvoices === void 0 ? void 0 : filteredInvoices.length) || 0, ")"), sortKey: undefined }), isMakingInvoices && (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { style: { marginLeft: '4px' } })] })) })), (0, jsx_runtime_1.jsxs)(TableBody_1.default, { children: [pagedInvoices.map(function (invoice) { return ((0, jsx_runtime_1.jsx)(InvoiceElement_1.default, { showStatus: true, item: invoice, tableConf: tableConf_1.invoiceDetailsListViewTableConf, placement: "listPage" }, invoice.id)); }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { height: hasMore ? '30px' : 0, overflowAnchor: 'none', textAlign: 'center', cursor: 'pointer' }, ref: loaderRef }, { children: hasMore && 'Click to load more...' }))] })] })) })) }))] }))] })));
};
var InvoicesPageWrapper = function () {
    var filterKey = (0, react_router_dom_1.useParams)().filterKey;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _a = __read((0, backend_1.useCall)('invoicing-makeinvoicesforaccfirm', { companyId: company === null || company === void 0 ? void 0 : company.id }), 2), makeInvoices = _a[0], isMakingInvoices = _a[1];
    (0, react_1.useEffect)(function () { return void makeInvoices()(); }, [company === null || company === void 0 ? void 0 : company.id]);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'recharge_invoices', where: [['companyId', '==', company === null || company === void 0 ? void 0 : company.id]] }]; });
    return (0, jsx_runtime_1.jsx)(InvoicesPage, { filterKey: filterKey, isMakingInvoices: isMakingInvoices }, filterKey);
};
exports.InvoicesPageWrapper = InvoicesPageWrapper;
exports.default = (0, HoCs_1.HasCompanyHoC)(exports.InvoicesPageWrapper);
